export default __webpack_public_path__ + "1678b1de4ee4e47654af9785047b9e9c.png";